import React, { Component } from "react";
import PropTypes from "prop-types";

export class Button extends Component {

	renderClassName() {
		const { className, primary, secondary, tertiary, disabled } = this.props;
		let string = "btn waves-effect";
		if(primary) string = string.concat(" -primary");
		if(secondary) string = string.concat(" -secondary");
		if(tertiary) string = string.concat(" -tertiary");
		if(disabled) string = string.concat(" -disabled");
		if(className) string = string.concat(` ${className}`);
		return string;
	}

	render() {
		const { children, clickAction, id, disabled } = this.props;

		return (
			<button
				className={this.renderClassName()}
				onClick={clickAction}
				disabled={disabled}
			>
				{children}
			</button>
		);
	}
}

Button.propTypes = {
	primary: PropTypes.bool,
	children: PropTypes.node,
	secondary: PropTypes.bool,
	className: PropTypes.string,
	clickAction: PropTypes.func.isRequired,
	id: PropTypes.string
};

Button.defaultProps = {
	primary: false,
	children: "",
	secondary: false,
	className: "",
	clickAction: () => console.log("NOT IMPLEMENTED"),
	id: null
};


// WEBPACK FOOTER //
// src/atoms/lib/Button.js